import { ValueObject } from "./ValueObject";

export class Color implements ValueObject {

  constructor(
    public readonly r: number,
    public readonly g: number,
    public readonly b: number,
    public readonly a: number = 1,
  ) { }

  public static none: Color = new Color(0, 0, 0, 0);
  public static black: Color = new Color(0, 0, 0);
  public static white: Color = new Color(255, 255, 255, 1);


  get rgba(): string {
    const { r, g, b, a } = this;
    return `rgba(${r},${g},${b},${a})`;
  }

  eq(v: Color): boolean {
    const { r, g, b, a } = this;
    return r === v.r && g === v.g && b === v.b && a === v.a;
  }

  clone(): Color {
    return new Color(this.r, this.g, this.b, this.a);
  }

}